// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".translate-history-dialog .sign{font-style:italic;color:gray;text-align:right;font-size:10pt}", ""]);
// Exports
module.exports = exports;
